import client from "./internal/httpClient";

export function login(data) {
  return client.post("/login",data);
}


export function logout() {
  return client.post("/api/v1/auth/logout", {});
}


